import styled from "styled-components";

export const SupportMessageContainer = styled.p`
  a {
    color: ${(props) => props.theme.colors.LINK_COLOR};
    text-decoration: none;
    margin: 0 0.4em;

    &:hover {
      text-decoration: underline;
    }
  }
`;
